// Temporarily disabled
function HowToFooter() {
  return null;
}

/* Original implementation - re-enable when form solution is ready
import * as React from 'react';
import { HubspotSurvey } from './HubspotSurvey';

function HowToFooter() {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleSurveyOpen = () => {
    setIsModalOpen(true);
  };

  const styles = {
    howToFooter: {
      marginTop: '16px',
      display: 'flex',
      justifyContent: 'center'
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    text: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(25, 84, 235, 0.08)'
      }
    },
    paragraph: {
      color: '#1954eb',
      fontWeight: 500,
      fontSize: '14px',
      margin: 0
    }
  };

  return (
    <div className='how-to-footer' style={styles.howToFooter}>
      <div className='how-to-footer__content' style={styles.content}>
        <div
          className='how-to-footer__text'
          onClick={handleSurveyOpen}
          style={styles.text}
        >
          <p style={styles.paragraph}>
            Can't find your platform? Suggest it here.
          </p>
        </div>
        <div className='how-to-footer__survey'>
          <HubspotSurvey
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            formId='0999da53-676f-42e4-b04e-63640dca5cd9'
            portalId='23573381'
          />
        </div>
      </div>
    </div>
  );
}
*/

export default HowToFooter;
